export type IncentiveOfferSortOption = 'price' | 'date';

type SortOptionConfig = {
  label: string;
  value: IncentiveOfferSortOption;
};

export const incentiveOffersSortOptions: SortOptionConfig[] = [
  {
    label: 'Price',
    value: 'price',
  },
  {
    label: 'Date',
    value: 'date',
  },
];

export default incentiveOffersSortOptions;
